import { ItemModel } from "../models/ItemModel";

export interface ItemValidatonErrors {
    itemName?: string;
    primaryImage?: string;
    price?: string;
    description?: string;
    rootCategory?: string;
    subCategory?: string;
    featured?:string;
    keywords?: string;
}

export type ItemFormState = {
    item: ItemModel;
    errors: ItemValidatonErrors;
    isSubmitting: boolean;
    isDeleting: boolean;
    serviceSuccess: string;
    serviceError: string;
};

export type ItemFormAction =
    | { type: "SET_ITEM"; payload: Partial<ItemModel> }
    | { type: "RESET_ITEM"; payload: ItemModel }
    | { type: "SET_ERRORS"; payload: ItemValidatonErrors }
    | { type: "CLEAR_ERRORS" }
    | { type: "SET_SUBMITTING"; payload: boolean }
    | { type: "SET_DELETING"; payload: boolean }
    | { type: "SET_SUCCESS"; payload: string }
    | { type: "SET_ERROR"; payload: string };

export default function itemFormReducer(state: ItemFormState, action: ItemFormAction): ItemFormState {
    switch (action.type) {
        case "SET_ITEM":
            return {
                ...state,
                item: { ...state.item, ...action.payload },
            };
        case "RESET_ITEM":
            return {
                ...state,
                item: new ItemModel({ ...action.payload }),
                errors: {},
            };
        case "SET_ERRORS":
            return {
                ...state,
                errors: action.payload,
            };
        case "CLEAR_ERRORS":
            return {
                ...state,
                errors: {},
            };
        case "SET_SUBMITTING":
            return {
                ...state,
                isSubmitting: action.payload,
            };
        case "SET_DELETING":
            return {
                ...state,
                isDeleting: action.payload,
            };
        case "SET_SUCCESS":
            return {
                ...state,
                serviceSuccess: action.payload,
                serviceError: "",
            };
        case "SET_ERROR":
            return {
                ...state,
                serviceError: action.payload,
                serviceSuccess: "",
            };
        default:
            return state;
    }
}